import Moment from 'moment'
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import TransferAction from "Store/Component/Transfer/TransferAction";
import { getDispositionChoice, getDispositionSubChoice } from "Store/OrderManagement/DispositionChoice/DispositionChoiceAction";
import Disposition from "./Disposition"
import Validation from "./dispositionValidation";
import SubChoiceValidation from "./DispositionSubChoices/dispositionSubChoicesValidation";
import { CONSTANTS } from "client/utils/constants";
import { useNavigate, useParams } from "react-router-dom";
import ConfirmationBee from "../../../../../../assets/images/ConfirmationBee.svg";
import RejectedBee from "../../../../../../assets/images/PenndingApproval/Rejected Bee.png";
import RequisitionAction from "Store/Component/Requisition/RequisitionAction";
import { setCities } from "Store/Organization/Cities/CitiesAction";
import pendingOrderOperations from 'redux/PendingOrder/operations';
import { APIToReact } from "Service/Transfer/ObjectStructure";
import navOperations from "redux/Navigation/operations";
import { resetAllAssetOrderData } from "client/utils/AssetUtil";
import { DispositionTypeRequiredAttachment } from "./DispositionTypeAttachment";
import { setAddressDetails } from "Store/Organization/AutoCompleteAddressDetails/AddressDetailsAction";
import OrderDispatch from 'Store/OrderManagement/Order/OrderDispatch'
import { getDispositionPenaltyFee, setDispositionPenaltyFee } from "Store/OrderManagement/DispositionPenaltyFee/DispositionPenaltyFeeAction";
import { setDeleteCartOrder } from 'Store/OrderManagement/Order/OrderAction';
import { setTransferOrderById } from 'Store/Transfer/Transfer/TransferOrderByIdAction';
import { setBillOfSaleUrl, setIsBillOfSaleCreated } from 'Store/OrderManagement/BillOfSale/BillOfSaleAction';

const DispositionContainer = (props: any) => {

    const {
        isRevertChanges,
        setIsRevertChanges,
        setAssetDetailList,
        assetDetailList,
        setTotalPenaltyFee,
        totalPenaltyFee,
        setShoweExemptionFields,
        showExemptionFields
    } = props

    const dispatch = useDispatch();
    const dispatchNav = navOperations.dispatchNav(dispatch);
    const navigate = useNavigate();

    const choices = [CONSTANTS.DISPOSITION_CHOICES.FMC_AUCTION_LEASED, CONSTANTS.DISPOSITION_CHOICES.FMC_AUCTION_OWNED, undefined, null]
    const cancelOrderRequest = pendingOrderOperations.dispatchCancelOrderRequest(dispatch);
    const dispatchSetIsOrderCanceled = pendingOrderOperations.dispatchSetIsOrderCanceled(dispatch);
    const dispatchGetDeleteCartOrderById = OrderDispatch.dispatchGetDeleteCartOrder(dispatch);

    const processTypeOptions = [
        { value: 'REM', label: 'REM' },
        { value: 'Fleet', label: 'Fleet' }
    ]
    const [assetDisposition, setAssetDisposition] = useState<any>([]);
    const [isCartUpdated, setIsCartUpdated] = useState<any>(false);
    const [isDispositionAssetValid, setDispositionAssetValid] = useState(true)
    const [isLocationAssetValid, setLocationAssetValid] = useState(true)
    const [isEditOrder, setIsEditOrder] = useState(false)
    const [isCancelRequestClicked, setIsCancelRequestClicked] = useState(false)
    const [isDispositionChoiceChenged, setIsDispositionChoiceChanged] = useState(false);
    const [selectedDispositionChoice, setSelectedDispositionChoice] = useState<any>();
    const [isDispositionAssetLocationValid, setIsDispositionAssetLocationValid] = useState<any>(true)
    const [focusDispositionAssetInfoState, setFocusDispositionAssetInfoState] = useState(false)
    const AssetDispostionFieldRef = useRef<any>([]);
    const DispositionLocationFieldRef = useRef<any>([]);
    const [isEnableLocation, setIsEnableLocation] = useState<any>(false);
    const [showWarningPopup, setShowWarningPopup] = useState<any>(false);
    const [Popupcontent, setPopupcontent] = useState<any>({
        title: "",
        isDialogVisible: false,
        isTitleWarning: false,
        subtextcontent: "",
        primaryBtnText: "",
        outlineBtnText: "",
        isSingleConfirmationBtn: false,
        isCommentboxVisible: false,
        isCompletedReportVisible: false,
        titleImg: "",
        isCommentBoxRequire: false,
        outlineBtnnavigateTo: "",
        primaryBtnnavigateTo: "",
        actionby: "",
        value: 0,
        comment: "",
    });
    const [WarningPopupcontent, setWarningPopupcontent] = useState<any>({
        title: "",
        isDialogVisible: false,
        isTitleWarning: false,
        subtextcontent: "",
        primaryBtnText: "",
        outlineBtnText: "",
        isSingleConfirmationBtn: false,
        isCommentboxVisible: false,
        isCompletedReportVisible: false,
        titleImg: "",
        isCommentBoxRequire: false,
        outlineBtnnavigateTo: "",
        primaryBtnnavigateTo: "",
        actionby: "",
        value: 0,
        comment: "",
    });
    const { dispositionList,
        dispositionSubChoiceList,
        dispositionCartList,
        dispositionChoiceList,
        reasonCodeList,
        assetsList,
        attachmentsList,
        transferOrderByIdData,
        getUserDetails,
        isOrderCanceled,
        headerNav,
        dispositionPenaltyFee,
        globalPenaltyFlag,
        cartOrderDelete
         }: any = useSelector((state?: any) => ({
            dispositionList: state.TransferReducer.dispositionList,
            dispositionSubChoiceList: state.DispositionChoiceReducer.dispositionSubChoiceList,
            dispositionCartList: state.TransferReducer.dispositionCartList,
            dispositionChoiceList: state.DispositionChoiceReducer.dispositionChoiceList,
            reasonCodeList: state.ReasonCodeReducer.reasonCodeList,
            assetsList: state.TransferReducer.assets,
            attachmentsList: state.UploadAttachmentsReducer.list,
            transferOrderByIdData: state.TransferOrderReducer.transferOrderByIdData,
            getUserDetails: state.UserProfile.getUserDetails,
            isOrderCanceled: state.PendingOrder.isOrderCanceled,
            headerNav: state.nav.headerNav,
            dispositionPenaltyFee: state.DispositionPenaltyFeeReducer.dispositionPenaltyFee,
            globalPenaltyFlag: state.DispositionPenaltyFeeReducer.globalPenaltyFlag,
            cartOrderDelete: state.OrderReducer.cartOrderDelete
        }));

    const dispositionChoiceDropdownList = dispositionChoiceList?.map((item: any) =>
        ({ label: item.text, key: item.value, ...item })
    );

    const reasonCodeDropdownList = reasonCodeList?.map((item: any) =>
        ({ label: item.text, key: item.value, ...item })
    );

    useEffect(() => {
        if(dispositionChoiceDropdownList){
            let hasOption = dispositionChoiceDropdownList?.filter((item?: any) => item?.value == assetDisposition?.dispositionChoice?.value);
            if(!hasOption?.length){
                let val = { value: "", text: '' }
                changeDispositionchoice(val);
            }
            
        }
    },[dispositionChoiceList])

    useEffect(() => {
        if (totalPenaltyFee == 0) {
            const order = JSON.parse(JSON.stringify(dispositionList));
            order.isWriteOffPenaltyExemption = false
            order.assetDispositionPenaltyExemptionReason = ""
            setAssetDisposition({ ...assetDisposition, isWriteOffPenaltyExemption: false, assetDispositionPenaltyExemptionReason: "" });

            dispatch(TransferAction.setIDisposition({
                ...dispositionList,
                ...order
            }));
        }
    }, [totalPenaltyFee])

    let { id } = useParams();

    useEffect(() => {
        if(id){
            updateAllState();
            props.setIsRevertChanges(false)
        }
    }, [props.isRevertChanges])
    useEffect(() => {
        if (dispositionCartList?.length <= 0) {
            setIsCartUpdated(false);
            props.setShowCart(false);
            props.setShowCartClicked(false)
        }
    }, [dispositionCartList])

    useEffect(() => {
        !id && AssetDispostionFieldRef?.current[0]?.focus();     
    }, [])

    useEffect(() => {
        props?.updateCartStateRef && AssetDispostionFieldRef?.current[0]?.focus();     
    }, [props?.updateCartStateRef])

    useEffect(() => {
        let isLeased = false;
        if(assetsList[0]?.leasedvsOwned == CONSTANTS.LEASED){
          isLeased = true;
        }
        dispatch(getDispositionChoice(isLeased));
        dispatch(TransferAction.setIDisposition({
            ...dispositionList,
            assetDispositionProcessType : "REM"
        }));
        if (id) {
            updateAllState();
            setIsEditOrder(true);
        }else{
            setIsEditOrder(false)
        }
    }, []);

    useEffect(() => {
        if (id) {
            updateAllState();
            setIsEditOrder(true);
            let total = 0;
            let assetsListTemp = assetsList?.length > 0 ? JSON.parse(JSON.stringify(assetsList)) : []
            assetsListTemp?.forEach((assetItem?: any) => {
              total = total + assetItem.dispositionPenalityFee;
            })
            setTotalPenaltyFee(total);
        }
    }, [dispositionList])

    useEffect(() => {
        if (isEditOrder) {
            setLocationAssetValid(false)
        }
    }, [isEditOrder])

    useEffect(() => {
        validate()
        if (!dispositionList?.assetDispositionChoice) {
            setIsEnableLocation(false)
        }
        else if (dispositionList?.assetDispositionChoice?.toLowerCase().includes("write-off")) {
            setIsEnableLocation(false)
        }
        else {
            setIsEnableLocation(true)
        } 
    }, [dispositionList?.assetDispositionChoice])

    useEffect(() => {
        if ((isOrderCanceled.approval || cartOrderDelete) && isCancelRequestClicked) {
            setIsCancelRequestClicked(false);
            let decriptionTxt = (
                <div>
                    <p>Order Cancelled Successfully</p>
                </div>
            );
            setPopupcontent({
                ...Popupcontent,
                titleImg: RejectedBee,
                title: "CANCEL ORDER",
                isDialogVisible: true,
                isTitleWarning: false,
                subtextcontent: decriptionTxt,
                isCommentboxVisible: false,
                isCommentBoxRequire: false,
                outlineBtnText: "Close",
                isSingleConfirmationBtn: true,
                popupOutlinebtnOnclick: () => {
                    dispatchSetIsOrderCanceled(false)
                    dispatch(RequisitionAction.setIsChangesOccured(false))
                    resetAllAssetOrderData(dispatch);
                    dispatchNav(headerNav);
                    props.onCancelClick(false);
                    dispatch(setDeleteCartOrder(false))
                    navigate('/ordermanagement')
                    dispatch(setTransferOrderById({}))
                    dispatch(TransferAction.setAfeOrderByIdData({}))
                },
            });
        }else if((!isOrderCanceled.approval || !cartOrderDelete) && isCancelRequestClicked){
            setIsCancelRequestClicked(false);
            let decriptionTxt = (
                <div>
                    <p>Order Cancelled Failed</p>
                </div>
            );
            setPopupcontent({
                ...Popupcontent,
                titleImg: RejectedBee,
                title: "CANCEL ORDER",
                isDialogVisible: true,
                isCommentboxVisible: false,
                isCommentBoxRequire: false,
                isTitleWarning: false,
                subtextcontent: decriptionTxt,
                outlineBtnText: "Close",
                isSingleConfirmationBtn: true,
                popupOutlinebtnOnclick: () => {
                    hideDialog();
                    dispatch(setDeleteCartOrder(false))
                },
            });
        }
    }, [isOrderCanceled?.approval, cartOrderDelete])

    const updateAllState = () => {
        let temp = JSON.parse(JSON.stringify(assetDisposition))
            temp.dispositionChoice = {
                label: dispositionList?.assetDispositionChoice,
                key: dispositionList?.assetDispositionChoiceId,
                value: dispositionList?.assetDispositionChoiceId,
                text: dispositionList?.assetDispositionChoice
            }
            temp.processType = {
                label: dispositionList?.assetDispositionProcessType,
                key: dispositionList?.assetDispositionProcessTypeId,
                value: dispositionList?.assetDispositionProcessTypeId,
                text: dispositionList?.assetDispositionProcessType
            }
            temp.reasonCode = {
                label: dispositionList?.assetDispositionReasonCode,
                key: dispositionList?.assetDispositionReasonCodeId,
                value: dispositionList?.assetDispositionReasonCodeId,
                text: dispositionList?.assetDispositionReasonCode
            }
            temp.replacementFleetAssetOrder = dispositionList?.assetDispositionReplacementFleetAssetOrder
            temp.replacementFleetAsset = dispositionList?.assetDispositionReplacementFleetAsset
            if(dispositionCartList?.length > 0 || dispositionCartList != undefined){
                setAssetDisposition(temp);
                setIsCartUpdated(true);
               
                //props.setSuccessAlert(false)
                if (props.mobile) {
                    props.setShowCreateRequisition(true)
                    props.setShowCartClicked(false)
                    props.setShowCart(false);
                }
                else {
                    props.setShowCreateRequisition(true)
                    props.setShowCartClicked(true)
                    props.setShowCart(true);
                }
                //setDispositionAssetValid(false)
                //setLocationAssetValid(false)
                setIsDispositionAssetLocationValid(false)
            }
    }
    useEffect(() => {
        if (id && assetDisposition?.dispositionChoice?.text?.length && assetDisposition?.dispositionChoice?.text != undefined && dispositionSubChoiceList === undefined) {
            if (choices.includes(assetDisposition?.dispositionChoice?.text)) {
                dispatch(getDispositionSubChoice(assetDisposition?.dispositionChoice?.value))
            }
        }
    }, [assetDisposition])


    let initialDispositionSubChoice = {
        assetDispositionSubChoice: '',
        assetDispositionSubChoiceId: '',
        assetDispositionName: '',
        assetDispositionAddress1: '',
        assetDispositionAddress2: '',
        assetDispositionCity: '',
        assetDispositionState: '',
        assetDispositionZip: '',
        assetDispositionPhone: '',
        assetDispositionSalePrice: '',
        assetDispositionTotalPrice: '',
        assetDispositionNameError: '',
        assetDispositionPhoneError: '',
        assetDispositionAddress1Error: '',
        assetDispositionAddress2Error: '',
        assetDispositionCityError: '',
        assetDispositionStateError: '',
        assetDispositionZipError: '',
        assetDispositionSubChoiceError: '',
        assetDispositionSalePriceError: ''
    }

    const isValidForPenaltyFee = (selectedOption?: any) => {
        if (selectedOption == CONSTANTS.DISPOSITION_CHOICES.WRITE_OFF_OWNED_ASSET_NO_TITLE || 
            selectedOption == CONSTANTS.DISPOSITION_CHOICES.WRITE_OFF_LEASED_ASSET_NO_TITLE ||
            selectedOption == CONSTANTS.DISPOSITION_CHOICES.WRITE_OFF_OWNED_ASSET_TITLED || 
            selectedOption == CONSTANTS.DISPOSITION_CHOICES.WRITE_OFF_LEASED_ASSET_TITLED) {
         return true
        }else{
            return false
        }
    }

    useEffect(() => {
        if (isValidForPenaltyFee(dispositionList?.assetDispositionChoice)) {
            setShoweExemptionFields(true)
        }
    }, [dispositionList?.assetDispositionChoice])

const changeDispositionchoice = (selectedOption?: any) => {
        dispatch(setAddressDetails({}))
        dispatch(RequisitionAction.setIsChangesOccured(true))
        const order = { ...dispositionList, ...initialDispositionSubChoice };
        order.assetDispositionChoice = selectedOption.text
        order.assetDispositionChoiceId = selectedOption.value
        let error = { ...Validation.ValidateDispositionChoice(order, { ...order }) };
        setAssetDisposition({ ...assetDisposition, dispositionChoice: selectedOption, assetDispositionPenaltyExemptionReason: '', isWriteOffPenaltyExemption : false });
        setIsDispositionChoiceChanged(true)
        isDispositionValidate(error, { ...assetDisposition, dispositionChoice: selectedOption })
        error.assetDispositionChoiseAttatmentNote = DispositionTypeRequiredAttachment(selectedOption.text)
        if (choices.includes(selectedOption.text)) {
            dispatch(getDispositionSubChoice(selectedOption.value))
        }
        dispatch(TransferAction.setIDisposition({
            ...dispositionList,
            ...order,
            ...error,
            assetLocationName: null,
              assetLocationContactName: '',
              assetLocationEmail: '',
              assetLocationContactPhone: '',
              assetLocationAddress1: '',
              assetLocationAddress2: '',
              assetLocationCity: '',
              assetLocationState: '',
              assetLocationZip: '',
              assetLocationNameError: '',
              assetLocationContactNameError: '',
              assetLocationEmailError: '',
              assetLocationContactPhoneError: '',
              assetLocationAddress1Error: '',
              assetLocationAddress2Error: '',
              assetLocationCityError: '',
              assetLocationStateError: '',
              assetLocationZipError: '',
              assetDispositionPenaltyExemptionReason: '',
              isWriteOffPenaltyExemption: false
        }));  
        if(selectedOption?.text === CONSTANTS.DISPOSITION_CHOICES.FMC_AUCTION_LEASED
            || selectedOption?.text === CONSTANTS.DISPOSITION_CHOICES.FMC_AUCTION_OWNED) {
              AssetDispostionFieldRef?.current[1]?.focus()
        }
        if(selectedOption?.text === CONSTANTS.DISPOSITION_CHOICES.SELL_TO_LEASED_THIRD_PARTY
        || selectedOption?.text === CONSTANTS.DISPOSITION_CHOICES.SELL_TO_OWNED_THIRD_PARTY){
            AssetDispostionFieldRef?.current[2]?.focus()
        }   
        if (!selectedOption?.text) {
            setIsEnableLocation(false)
            setLocationAssetValid(false)
        }
        else if (selectedOption?.text?.toLowerCase().includes("write-off")) {
            setIsEnableLocation(false)
        }
        else {
            setIsEnableLocation(true)
            setLocationAssetValid(true)
        }
}

    const changeChoiceAndFee = (DispositionChoice?: any) => {
        changeDispositionchoice(DispositionChoice)
        let assetsListTemp = assetsList?.length > 0 ? JSON.parse(JSON.stringify(assetsList)) : []
        assetsListTemp?.forEach((assetItem?: any) => {
            assetItem.dispositionPenalityFee = ""
        })
        dispatch(TransferAction.setAssetData(assetsListTemp))
        let assetDetailListTemp = assetDetailList?.length > 0 ? JSON.parse(JSON.stringify(assetDetailList)) : []
        assetDetailListTemp?.forEach((assetDetailItem?: any) => {
            assetDetailItem.dispositionPenalityFee = ""
        })
        setAssetDetailList(assetDetailListTemp)
    }

    const onChangeDispositionChoice = (selectedOption: any) => {
        changeDispositionchoice(selectedOption)
        setShoweExemptionFields(false)
        setSelectedDispositionChoice(selectedOption)
        if (isValidForPenaltyFee(selectedOption?.text) && globalPenaltyFlag) {
            setShowWarningPopup(true)
            let payload: any = []
            assetsList?.map((assetsListItem?: any) => {
                payload?.push({
                    accountingClass: assetsListItem?.accountObject ? assetsListItem?.accountObject.toString() : '',
                    aquisitionCode: assetsListItem?.acquisitionCode ? assetsListItem?.acquisitionCode.toString() : '',
                    dateAcquired: assetsListItem?.dateAcquired ? Moment(assetsListItem?.dateAcquired).format("YYYY-MM-DD") : null,
                    netBookedValue: assetsListItem?.netBookedValue ? parseInt(assetsListItem?.netBookedValue) : 0,
                    disposeGainLoss: assetsListItem?.disposeGainLoss ? parseInt(assetsListItem?.disposeGainLoss) : 0,
                    cost: assetsListItem?.acquisitionCost ? parseInt(assetsListItem?.acquisitionCost) : 0,
                    assetNumber: assetsListItem?.assetNumber ? assetsListItem?.assetNumber.toString() : '',
                    lifeMonths: assetsListItem?.lifeMonths ? parseInt(assetsListItem?.lifeMonths) : 0,
                })
            })

            dispatch(getDispositionPenaltyFee(payload))
        } else {
            setShowWarningPopup(false)
            changeChoiceAndFee(selectedOption)
        }
    }

    const onchangeIsPenalityExemption = (e?: any, item?: any) => {
        dispatch(RequisitionAction.setIsChangesOccured(true))
        const order = JSON.parse(JSON.stringify(dispositionList));
        order.isWriteOffPenaltyExemption = item
        setAssetDisposition({ ...assetDisposition, isWriteOffPenaltyExemption: item });
        if(item && !isEmptyData(order?.assetDispositionPenaltyExemptionReason)){
            setDispositionAssetValid(true)
        }else{
            setDispositionAssetValid(false)
        }
        dispatch(TransferAction.setIDisposition({
            ...dispositionList,
            ...order
        }));
    }

    const onchangePenaltyExemptionReason = (e?: any) => {
        dispatch(RequisitionAction.setIsChangesOccured(true))
        const order = JSON.parse(JSON.stringify(dispositionList));
        order.assetDispositionPenaltyExemptionReason = e.target.value
        let error = { ...Validation.ValidatePenaltyExemptionReason(order?.isWriteOffPenaltyExemption, e.target.value, { ...order }) };
        setAssetDisposition({ ...assetDisposition, assetDispositionPenaltyExemptionReason: e.target.value });
        isDispositionValidate(error, { ...assetDisposition, assetDispositionPenaltyExemptionReason: e.target.value })
        dispatch(TransferAction.setIDisposition({
            ...dispositionList,
            ...order,
            ...error
        }));
    }

    useEffect(() => {
        if (dispositionPenaltyFee && showWarningPopup) {
            let fee = 0;
            dispositionPenaltyFee?.forEach((feeValue: any) => {
                fee = fee + feeValue?.penaltyFee
            })
            if(fee != 0){
            setTotalPenaltyFee(fee);
            let decriptionTxt = (
                <div>
                    <p>A ${parseFloat(`${fee}`).toFixed(2)} Penalty Fee will be assessed if you proceed with this Disposition Choice</p>
                </div>
            );
            setWarningPopupcontent({
                ...WarningPopupcontent,
                titleImg: ConfirmationBee,
                title: "Disposition Penalty Warning !",
                isDialogVisible: true,
                isTitleWarning: false,
                subtextcontent: decriptionTxt,
                outlineBtnText: "No",
                primaryBtnText: "Yes",
                isSingleConfirmationBtn: false,
                popupOutlinebtnOnclick: () => {
                    warningHideDialog();
                    setShowWarningPopup(false)
                    dispatch(setDispositionPenaltyFee([]));
                    let val = { value: "", text: '' }
                    changeDispositionchoice(val);
                },
                popupPrimarybtnOnclick: () => {
                    setShoweExemptionFields(true)
                    dispatch(setDispositionPenaltyFee([]))
                    setShowWarningPopup(false)
                    changeDispositionchoice(selectedDispositionChoice)
                    let assetsListTemp = assetsList?.length > 0 ? JSON.parse(JSON.stringify(assetsList)) : []
                    let assetDetailListTemp = assetDetailList?.length > 0 ? JSON.parse(JSON.stringify(assetDetailList)) : []
                    dispositionPenaltyFee?.forEach((feeValue: any) => {
                        assetsListTemp?.forEach((assetItem?: any) => {
                            if (feeValue?.assetNumber == assetItem?.assetNumber) {
                                assetItem.dispositionPenalityFee = feeValue?.penaltyFee
                            }
                        })
                        assetDetailListTemp?.forEach((assetDetailItem?: any) => {
                            if (feeValue?.assetNumber == assetDetailItem?.assetNumber) {
                                assetDetailItem.dispositionPenalityFee = feeValue?.penaltyFee
                            }
                        })
                    })
                    dispatch(TransferAction.setAssetData(assetsListTemp))
                    setAssetDetailList(assetDetailListTemp)
                    warningHideDialog();
                },
            });
        }else{
            changeChoiceAndFee(selectedDispositionChoice)
            setShowWarningPopup(false)
        }
        if(fee == 0 || fee == undefined || fee == null){
            setShoweExemptionFields(false)
        }
        }
    }, [dispositionPenaltyFee])
       
    const warningHideDialog = () => {
        setWarningPopupcontent({ ...WarningPopupcontent, isDialogVisible: false })
    }
    const onChangeProcessType = (selectedOption: any) => {
        dispatch(RequisitionAction.setIsChangesOccured(true))
        const order = JSON.parse(JSON.stringify(dispositionList));
        order.assetDispositionProcessType = selectedOption.value
        order.assetDispositionProcessTypeId = selectedOption.value
        let error = { ...Validation.ValidateProcessType(order, { ...order }) };
        setAssetDisposition({ ...assetDisposition, processType: selectedOption });
        isDispositionValidate(error, { ...assetDisposition, processType: selectedOption })
        dispatch(TransferAction.setIDisposition({
            ...dispositionList,
            ...order,
            ...error
        }));
    }

    const onChangeReasonCode = (selectedOption: any) => {
        dispatch(RequisitionAction.setIsChangesOccured(true))
        const order = JSON.parse(JSON.stringify(dispositionList));
        order.assetDispositionReasonCode = selectedOption.text
        order.assetDispositionReasonCodeId = selectedOption.value
        let error = { ...Validation.ValidateDispositionReasonCode(order, { ...order }) };
        setAssetDisposition({ ...assetDisposition, reasonCode: selectedOption });
        isDispositionValidate(error, { ...assetDisposition, reasonCode: selectedOption })
        dispatch(TransferAction.setIDisposition({
            ...dispositionList,
            ...order,
            ...error
        }));
    }

    const onChangeReplacementFleetAssetOrder = (selectedOption: any) => {
        dispatch(RequisitionAction.setIsChangesOccured(true))
        const order = JSON.parse(JSON.stringify(dispositionList));
        order.assetDispositionReplacementFleetAssetOrder = selectedOption.target.value
        let error = { ...Validation.ValidateReplacementFleetAssetOrder(selectedOption.target.value, { ...order }) };
        setAssetDisposition({ ...assetDisposition, replacementFleetAssetOrder: selectedOption.target.value });

        dispatch(TransferAction.setIDisposition({
            ...dispositionList,
            ...order,
            ...error
        }));
    }

    const onChangeReplacementFleetAsset = (selectedOption: any) => {
        dispatch(RequisitionAction.setIsChangesOccured(true))
        const order = JSON.parse(JSON.stringify(dispositionList));
        order.assetDispositionReplacementFleetAsset = selectedOption.target.value
        let error = { ...Validation.ValidateReplacementFleetAsset(selectedOption.target.value, { ...order }) };
        setAssetDisposition({ ...assetDisposition, replacementFleetAsset: selectedOption.target.value });
        dispatch(TransferAction.setIDisposition({
            ...dispositionList,
            ...order,
            ...error
        }));
    }

    const errors = [
        "assetLocationNameError",
        "assetLocationContactNameError",
        "assetLocationEmailError",
        "assetLocationContactPhoneError",
        "assetLocationAddress1Error",
        "assetLocationAddress2Error",
        "assetLocationCityError",
        "assetLocationStateError",
        "assetLocationZipError",
        "uploadAttachmentsError",
        "assetDispositionChoiceError",
        "assetDispositionPenaltyExemptionReasonError",
        // "assetDispositionProcessTypeError",
        // "assetDispositionReasonCodeError",
        "assetReplacementFleetAssetOrderError",
        "assetReplacementFleetAssetError",
        "assetDispositionNameError",
        "assetDispositionPhoneError",
        "assetDispositionSalePriceError",
        "assetDispositionTotalPriceError",
        "assetDispositionAddress1Error",
        "assetDispositionAddress2Error",
        "assetDispositionCityError",
        "assetDispositionStateError",
        "assetDispositionZipError",
        "assetDispositionSubChoiceError"
    ]
   

    const errorAssetSubDisposition = [
        "assetDispositionNameError",
        "assetDispositionPhoneError",
        "assetDispositionSalePriceError",
        "assetDispositionTotalPriceError",
        "assetDispositionAddress1Error",
        "assetDispositionAddress2Error",
        "assetDispositionCityError",
        "assetDispositionStateError",
        "assetDispositionZipError",
        "assetDispositionSubChoiceError"
    ]

    const errorAssetLocation = [
        "assetLocationNameError",
        "assetLocationContactNameError",
        "assetLocationEmailError",
        "assetLocationContactPhoneError",
        "assetLocationAddress1Error",
        "assetLocationAddress2Error",
        "assetLocationCityError",
        "assetLocationStateError",
        "assetLocationZipError",
    ]

    const isEmptyData = (e: any) => {
        switch (e) {
            case "":
            case null:
            case undefined:
                return false;
            default:
                return true;
        }
    }
    const isDispositionValidate = (data: any, dispositionData: any) => {
        const asset_disposition = (dispositionData ?? assetDisposition)
        if (isEmptyData(data.assetDispositionChoice) 
        ) {
            if (asset_disposition?.dispositionChoice?.text === CONSTANTS.DISPOSITION_CHOICES.SELL_TO_LEASED_THIRD_PARTY
                || asset_disposition?.dispositionChoice?.text === CONSTANTS.DISPOSITION_CHOICES.SELL_TO_OWNED_THIRD_PARTY) {
                if (
                    (isEmptyData(data.assetDispositionName) && data.assetDispositionName?.length <= 50) &&
                    (isEmptyData(data.assetDispositionPhone) && (data?.assetDispositionPhone)?.replace(/[^a-z\d\s]+/gi, "").length >= 10) &&
                    isEmptyData(data.assetDispositionSalePrice) &&
                    isEmptyData(data.assetDispositionTotalPrice) &&
                    isEmptyData(data.assetDispositionAddress1) &&
                    (data?.assetDispositionAddress2?.length <= 50 || data?.assetDispositionAddress2?.length == undefined)&&
                    (isEmptyData(data.assetDispositionCity) && data.assetDispositionCity?.length <= 100) &&
                    (isEmptyData(data.assetDispositionState) && data.assetDispositionState?.length <= 2) &&
                    (isEmptyData(data.assetDispositionZip) && data.assetDispositionZip?.length <= 10)
                ) {
                    setDispositionAssetValid(false)
                } else {
                    setDispositionAssetValid(true)
                }
            }
            else if (asset_disposition?.dispositionChoice?.text === CONSTANTS.DISPOSITION_CHOICES.FMC_AUCTION_LEASED
                || asset_disposition?.dispositionChoice?.text === CONSTANTS.DISPOSITION_CHOICES.FMC_AUCTION_OWNED) {
                if (
                    isEmptyData(data.assetDispositionSubChoice)
                ) {
                    setDispositionAssetValid(false)
                } else {
                    setDispositionAssetValid(true)
                }
            }else if(isValidForPenaltyFee(data.assetDispositionChoice)){
                if(data?.isWriteOffPenaltyExemption && (data?.assetDispositionPenaltyExemptionReason?.length > 500 || data?.assetDispositionPenaltyExemptionReason?.toString()?.trim()?.length == 0)){
                    setDispositionAssetValid(true)
                }else{
                    setDispositionAssetValid(false)
                }
            }
           
            else {
                setDispositionAssetValid(false)
            }
        } else {
            setDispositionAssetValid(true)
        }

    }

    const validate = () => {
        let assetDetailListTemp = assetsList?.length > 0 ? JSON.parse(JSON.stringify(assetsList)) : []
        let newAssetList: any = [];
        let invalidAsset: any = [];
        let dispositionTemp = JSON.parse(JSON.stringify(dispositionList))
        assetDetailListTemp?.forEach((asset: any) => {
            if(asset?.isAttachmentsRequired){
                newAssetList.push(asset);
            }           
        });
        let newList = newAssetList.filter((asset: any) => asset?.isAttachmentsRequired);

        assetDetailListTemp?.forEach((asset: any) => {
            if (!asset?.isValid) {
                invalidAsset.push(asset);
            }
        });
        if (!Validation.choices.includes(dispositionTemp?.assetDispositionChoice)) {
            if (attachmentsList?.length <= 0) {
                dispositionTemp.uploadAttachmentsError = "Please upload a file"
            }
            else { 
                dispositionTemp.uploadAttachmentsError = ""
            }
        }else if(dispositionTemp.uploadAttachmentsError = "Please upload a file"){
            dispositionTemp.uploadAttachmentsError = ""
        }
        if (isEnableLocation){
            dispositionTemp = { ...Validation.ValidateAssetLocationName(dispositionTemp, { ...dispositionTemp }) };
            dispositionTemp = { ...Validation.ValidateName(dispositionTemp, { ...dispositionTemp }) };
            dispositionTemp = { ...Validation.ValidateEmailAddress(dispositionTemp, { ...dispositionTemp }) };
            dispositionTemp = { ...Validation.ValidatePhone(dispositionTemp, { ...dispositionTemp }) };
            dispositionTemp = { ...Validation.ValidateAddress1(dispositionTemp, { ...dispositionTemp }) };
            dispositionTemp = { ...Validation.ValidateCity(dispositionTemp, { ...dispositionTemp }) };
            dispositionTemp = { ...Validation.ValidateState(dispositionTemp, { ...dispositionTemp }) };
            dispositionTemp = { ...Validation.ValidateZip(dispositionTemp, { ...dispositionTemp }) };
            dispositionTemp = { ...Validation.ValidateAddress2(dispositionTemp, { ...dispositionTemp }) };
        }
        dispositionTemp = { ...Validation.ValidateDispositionChoice(dispositionTemp, { ...dispositionTemp }) };
        dispositionTemp = { ...Validation.ValidateProcessType(dispositionTemp, { ...dispositionTemp }) };
        if(isValidForPenaltyFee(dispositionTemp?.assetDispositionChoice)){
            dispositionTemp = { ...Validation.ValidatePenaltyExemptionReason(dispositionTemp?.isWriteOffPenaltyExemption, dispositionTemp?.assetDispositionPenaltyExemptionReason, { ...dispositionTemp }) };
        }

        dispositionTemp = { ...SubChoiceValidation.ValidateDispositionSubChoice(dispositionTemp, { ...dispositionTemp }) };
        dispositionTemp = { ...SubChoiceValidation.ValidateName(dispositionTemp, { ...dispositionTemp }) };
        dispositionTemp = { ...SubChoiceValidation.ValidatePhone(dispositionTemp, { ...dispositionTemp }) };
        dispositionTemp = { ...SubChoiceValidation.ValidateAddress1(dispositionTemp, { ...dispositionTemp }) };
        dispositionTemp = { ...SubChoiceValidation.ValidateCity(dispositionTemp, { ...dispositionTemp }) };
        dispositionTemp = { ...SubChoiceValidation.ValidateState(dispositionTemp, { ...dispositionTemp }) };
        dispositionTemp = { ...SubChoiceValidation.ValidateZip(dispositionTemp, { ...dispositionTemp }) };
        dispositionTemp = { ...SubChoiceValidation.ValidateAddress2(dispositionTemp, { ...dispositionTemp }) };
        dispositionTemp = { ...SubChoiceValidation.ValidateSalePrice(dispositionTemp, { ...dispositionTemp }) };
        dispositionTemp = { ...SubChoiceValidation.ValidateTotalPrice(dispositionTemp, { ...dispositionTemp }) };
        dispatch(TransferAction.setIDisposition(dispositionTemp))
        let validToShowMyCart = true;

        for (let key in errors) {
            if (dispositionTemp[errors[key]]) {
                validToShowMyCart = false;
            }
            if (assetDisposition?.dispositionChoice?.text === CONSTANTS.DISPOSITION_CHOICES.SELL_TO_LEASED
                || assetDisposition?.dispositionChoice?.text === CONSTANTS.DISPOSITION_CHOICES.SELL_TO_OWNED
                || assetDisposition?.dispositionChoice?.text === CONSTANTS.DISPOSITION_CHOICES.FMC_AUCTION_LEASED
                || assetDisposition?.dispositionChoice?.text === CONSTANTS.DISPOSITION_CHOICES.FMC_AUCTION_OWNED) {
                if (dispositionTemp[errorAssetSubDisposition[key]]) {
                    setDispositionAssetValid(true)
                } else {
                    setDispositionAssetValid(false)
                }
            }
            isDispositionValidate(dispositionList, assetDisposition)
            if (dispositionTemp[errorAssetLocation[key]]) {
                setLocationAssetValid(true)
            }
        }
        if (newList?.length > 0) {
            validToShowMyCart = false;
        }
        if (invalidAsset?.length > 0) {
            validToShowMyCart = false;
        }
        return validToShowMyCart;
    }

    const onClickCancel = () => {
        const popUpDecriptionTxt = (
            <>
                <p>Entered details will be cleared.</p>
                <p>Are you sure you want to cancel the changes?</p>
            </>
        );
        setPopupcontent({
            ...Popupcontent,
            titleImg: ConfirmationBee,
            title: CONSTANTS.TITLE_CONFIRMATION,
            isDialogVisible: true,
            isTitleWarning: false,
            subtextcontent: popUpDecriptionTxt,
            primaryBtnText: "Yes",
            outlineBtnText: "No",
            popupOutlinebtnOnclick: () => {
                hideDialog();
            },
            popupPrimarybtnOnclick: () => {
                hideDialog();
                props.onCancelClick(false);
            },
            isSingleConfirmationBtn: false,
        });
        dispatch(setCities([]))
    }
    const hideDialog = () => {
        setPopupcontent({ ...Popupcontent, isDialogVisible: false })
    }


    const onClickAddToCart = () => {
        dispatch(RequisitionAction.setIsChangesOccured(true))
        const isValid = validate();
      
        if (isValid) {
            if(transferOrderByIdData?.orderStatus == "Saved"){
                dispatch(TransferAction.setIsChangesOccuredInCart(true))
              }
            setDispositionAssetValid(false)
            setLocationAssetValid(false)
            setIsDispositionAssetLocationValid(false)
            setIsCartUpdated(true);
            props.setShowCart(true);
            //  props.setShowCartClicked(true)
            props.setSuccessAlert(true)
            if (props.mobile) {
                props.setShowCreateRequisition(false)
                props.setShowCartClicked(false)
            }
            else {
                props.setShowCartClicked(true)
                props.setShowCreateRequisition(true)
            }
            let assetsListTemp = assetsList?.length > 0 ? JSON.parse(JSON.stringify(assetsList)) : []
            assetsListTemp?.forEach((assetItem: any) => {
                assetItem.isExist = true;
                assetItem.hide = assetsListTemp.length !== 1
            });
            
            dispatch(TransferAction.setCartIDisposition({
                ...dispositionList,
                requestIndex: 0,
                requestType: CONSTANTS.DISPOSITION,
                expand: true
            }));
            dispatch(setBillOfSaleUrl(null))
            if(dispositionList?.assetDispositionChoice == CONSTANTS.DISPOSITION_CHOICES.SELL_TO_OWNED_THIRD_PARTY || 
                dispositionList?.assetDispositionChoice == CONSTANTS.DISPOSITION_CHOICES.SELL_TO_LEASED_THIRD_PARTY){
                dispatch(setIsBillOfSaleCreated(false))
            }else{
                dispatch(setIsBillOfSaleCreated(true))
            }
            dispatch(TransferAction.setAssetCartData(assetsListTemp));
            
        } else {
            let popUpDecriptionTxt;
            let assetDetailListTemp = assetsList?.length > 0 ? JSON.parse(JSON.stringify(assetsList)) : []

            let newAssetList: any = [];
            let invalidAsset: any = [];
            let errorList: any = [];
            assetDetailListTemp?.forEach((asset: any) => {
                if(asset?.isAttachmentsRequired){
                    newAssetList.push(asset);
                }
            });

            assetDetailListTemp?.forEach((asset: any) => {
                if (!asset?.isValid) {
                    invalidAsset.push(asset);
                }
            });       
            let newList = newAssetList.filter((asset: any) => asset?.isAttachmentsRequired);
            for (let key in errors) {
                if (dispositionList[errors[key]] && dispositionList[errors[key]] != "Please upload a file") {          
                    errorList.push(dispositionList[errors[key]])
                }
            }

            
            if (errorList?.length && newList?.length > 0) {             
                popUpDecriptionTxt = "Please fill all the required fields"
            } else if (errorList?.length && newList?.length <= 0) {
                popUpDecriptionTxt = "Please fill all the required fields in Asset Disposition and Asset Location"
            } else if (newList?.length > 0) {             
                popUpDecriptionTxt = "Please fill all the asset information details"
            } else if (invalidAsset?.length > 0) {             
                popUpDecriptionTxt = "Please fill all the asset information details"
            } else {
                popUpDecriptionTxt = "Please fill all the required fields in Asset Disposition and Asset Location"
            }
            setPopupcontent({
                ...Popupcontent,
                titleImg: ConfirmationBee,
                title: 'Validation',
                isDialogVisible: true,
                isTitleWarning: false,
                subtextcontent: popUpDecriptionTxt,
                primaryBtnText: "",
                outlineBtnText: "Close",
                popupOutlinebtnOnclick: () => {
                    hideDialog();
                    setFocusDispositionAssetInfoState(!focusDispositionAssetInfoState)
                },
                isSingleConfirmationBtn: true,
            });
        }
    }

    useEffect(()=>{
        let isTempValid = true;
        let assetDetailListTemp = assetsList?.length > 0 ? JSON.parse(JSON.stringify(assetsList)) : []

        assetDetailListTemp?.forEach((asset: any) => {
            if (!asset?.isValid) {
                isTempValid = false
            }
        });

        if(!isTempValid) {
            setTimeout(() => {
                const elem = document.getElementsByClassName('item-details-requisition')[0] as HTMLElement;
                const top = elem?.offsetTop;
                document.getElementsByClassName('content-wrapper')[0].scrollTop = top - 10
              },200)
        }   
    },[focusDispositionAssetInfoState])

    const onClickReset = (e:any) => {
        e.preventDefault();
        setIsDispositionAssetLocationValid(true);
        setDispositionAssetValid(true)
        setLocationAssetValid(true)
        dispatch(RequisitionAction.setIsChangesOccured(true))
        setAssetDisposition([]);
        let dispositionTemp = {
            ...dispositionList,
            assetDispositionProcessType: 'REM',
            assetDispositionProcessTypeId: '',
            assetDispositionChoice: '',
            assetDispositionChoiceId: '',
            assetDispositionSubChoice: '',
            assetDispositionSubChoiceId: '',
            assetDispositionReasonCode: '',
            assetDispositionReasonCodeId: '',
            assetDispositionReplacementFleetAssetOrder: '',
            assetDispositionReplacementFleetAsset: '',
            assetDispositionName: '',
            assetDispositionAddress1: '',
            assetDispositionAddress2: '',
            assetDispositionCity: '',
            assetDispositionState: '',
            assetDispositionZip: '',
            assetDispositionPhone: '',
            assetDispositionSalePrice: '',
            assetDispositionTotalPrice: '',
            assetLocationName: '',
            assetLocationContactName: '',
            assetLocationEmail: '',
            assetLocationContactPhone: '',
            assetLocationAddress1: '',
            assetLocationAddress2: '',
            assetLocationCity: '',
            assetLocationState: '',
            assetLocationZip: '',
            assetDispositionPenaltyExemptionReason:'',
            isWriteOffPenaltyExemption: false,
            assetLocationNameError: '',
            assetLocationContactNameError: '',
            assetLocationEmailError: '',
            assetLocationContactPhoneError: '',
            assetLocationAddress1Error: '',
            assetLocationAddress2Error: '',
            assetLocationCityError: '',
            assetLocationStateError: '',
            assetLocationZipError: '',
            assetDispositionChoiceError: '',
            assetDispositionPenaltyExemptionReasonError: '',
            assetDispositionProcessTypeError: '',
            assetDispositionReasonCodeError: '',
            assetReplacementFleetAssetOrderError: '',
            assetReplacementFleetAssetError: '',
            assetDispositionNameError: '',
            assetDispositionPhoneError: '',
            assetDispositionSalePriceError: '',
            assetDispositionAddress1Error: '',
            assetDispositionAddress2Error: '',
            assetDispositionCityError: '',
            assetDispositionStateError: '',
            assetDispositionZipError: '',
            assetDispositionSubChoiceError: ''
        }
        dispatch(TransferAction.setIDisposition(
            { ...dispositionTemp }
        ))
        dispatch(TransferAction.setIsResetClicked(true))
    }

    const revertChangesOnClick = () => {
        APIToReact({
            dispatch,
            transferOrderByIdData
        })
        props.setIsRevertChanges(true)
    }

    const cancelRequestOnClick = () => {
        setIsCancelRequestClicked(true);
        const cancelOrdersubtext = (
            <div>
                <p>Are you sure you want to cancel the Order</p>
                <p>
                    <b>LEADR Order # : </b>{id}
                </p>
            </div>
        );
        setPopupcontent({
            ...Popupcontent,
            titleImg: RejectedBee,
            title: "CANCEL ORDER",
            isDialogVisible: true,
            isTitleWarning: false,
            subtextcontent: cancelOrdersubtext,
            primaryBtnText: "Yes",
            outlineBtnText: "No",
            isSingleConfirmationBtn: false,
            isCommentboxVisible: true,
            isCommentBoxRequire: true,
            isCompletedReportVisible: false,
            popupOutlinebtnOnclick: () => {
                hideDialog();
                setIsCancelRequestClicked(false)
            },
            popupPrimarybtnOnclick: (
                item: any,
                comment: string,
                actionby: string,
                value: any
            ) => {
                if (transferOrderByIdData?.orderStatus == "Saved") {
                    const deleteDraftOrder = {
                        orderId: transferOrderByIdData?.orderId,
                        comments: comment,
                        savedBy: getUserDetails?.emailId
                    };
                    dispatchGetDeleteCartOrderById(deleteDraftOrder)
                } else {
                    cancelOrderRequest({ orderId: transferOrderByIdData?.orderId, savedBy: getUserDetails?.emailId, comments: comment });
                }
                hideDialog();
            }
        });
    }

    const onClick = (e: any) => {
        e.stopPropagation();
    }
    
    const onClickLocationContainer = (e:any) =>{
        AssetDispostionFieldRef?.current[2]?.focus()
    }

    return (
        <Disposition
            dispositionChoiceDropdownList={dispositionChoiceDropdownList}
            assetDisposition={assetDisposition}
            onChangeDispositionChoice={onChangeDispositionChoice}
            onClickAddToCart={onClickAddToCart}
            onChangeProcessType={onChangeProcessType}
            onChangeReasonCode={onChangeReasonCode}
            onChangeReplacementFleetAssetOrder={onChangeReplacementFleetAssetOrder}
            onChangeReplacementFleetAsset={onChangeReplacementFleetAsset}
            processTypeOptions={processTypeOptions}
            reasonCodeDropdownList={reasonCodeDropdownList}
            dispositionList={dispositionList}
            isCartUpdated={isCartUpdated}
            onCancelClick={onClickCancel}
            Popupcontent={Popupcontent}
            hideDialog={hideDialog}
            id={id}
            onClickReset={onClickReset}
            isDispositionAssetValid={isDispositionAssetValid}
            isLocationAssetValid={isLocationAssetValid}
            setLocationAssetValid={setLocationAssetValid}
            isDispositionValidate={isDispositionValidate}
            isEditOrder={isEditOrder}
            transferOrderByIdData={transferOrderByIdData}
            cancelRequestOnClick={cancelRequestOnClick}
            revertChangesOnClick={revertChangesOnClick}
            isRevertChanges={isRevertChanges}
            setIsRevertChanges={setIsRevertChanges}
            isDispositionAssetLocationValid = {isDispositionAssetLocationValid}
            setIsDispositionChoiceChanged = {setIsDispositionChoiceChanged}
            isDispositionChoiceChenged = {isDispositionChoiceChenged}
            onClick={onClick}
            AssetDispostionFieldRef={AssetDispostionFieldRef}
            DispositionLocationFieldRef={DispositionLocationFieldRef}
            onClickLocationContainer={onClickLocationContainer}
            isEnableLocation={isEnableLocation}
            WarningPopupcontent={WarningPopupcontent}
            warningHideDialog={warningHideDialog}
            onchangePenaltyExemptionReason = {onchangePenaltyExemptionReason}
            isValidForPenaltyFee = {isValidForPenaltyFee}
            showExemptionFields = {showExemptionFields}
            onchangeIsPenalityExemption = {onchangeIsPenalityExemption}
            totalPenaltyFee = {totalPenaltyFee}
            globalPenaltyFlag = {globalPenaltyFlag}
        />
    )
}


export default DispositionContainer